import { render } from "./CameraStatusInfoText.vue?vue&type=template&id=6dcf643e&ts=true"
import script from "./CameraStatusInfoText.vue?vue&type=script&lang=ts"
export * from "./CameraStatusInfoText.vue?vue&type=script&lang=ts"

import "./CameraStatusInfoText.vue?vue&type=style&index=0&id=6dcf643e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__